import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

export interface IConditionalRouteProps extends RouteProps {
	isTrue: boolean;
	altPath: string;
}

/* Only When True Will This Route Render Component */
export class ConditionalRoute extends React.Component<IConditionalRouteProps> {
	render() {
		const { component, render, isTrue, path, ...rest } = this.props
		const redirectTo = this.props.altPath;
		console.debug('Rendering...' + path)
		let renderComponent = (props) => <Redirect to={redirectTo} />;
		if (isTrue) {
			console.debug('Component');
			if (component) {
				const Component = component;
				renderComponent = (props) => <Component {...props} />;
			} else if (render) {
				renderComponent = render as any;
			}
		} else {
			console.debug('Redirecting To..' + redirectTo);
		}

		return <Route render={renderComponent} {...rest} />
	}
}


// WEBPACK FOOTER //
// ./src/components/containers/ConditionalRoute.tsx